import { TValue } from 'src/app/models/generic';
import {
  Component,
  forwardRef,
  HostBinding,
  Input
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-c-input-legacy',
  templateUrl: './c-input-legacy.component.html',
  styleUrls: ['./c-input-legacy.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CInputLegacyComponent)
    }
  ]
})
export class CInputLegacyComponent implements ControlValueAccessor {
  @Input() @HostBinding('style.--select-width') width?: string;
  @Input() @HostBinding('style.--select-height') height?: string;
  @Input() placeholder: string = 'Assunto';
  @Input() readonly: boolean = false;
  @Input() value: TValue;

  onChange = (value: TValue): void => {};

  constructor() {}

  writeValue(value: TValue): void {
    this.value = value;
  }

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {}

  setDisabledState?(isDisabled: boolean): void {}
}
